import { createContext } from 'react';

import type { InFieldUserPreferences } from '@cognite/apm-client';

import { useCurrentUserContext } from '../../../providers/current-user-provider/current-user-provider';
import { useSavedCdmConfiguration } from '../../../providers/offline/cdm-use-saved-configuration';
import { useUpsertCurrentUserPreferences } from '../../user/hooks/use-mutation/cdm-use-upsert-user-preferences';
import type { UserPreferencesUpdate } from '../../user/hooks/use-mutation/mutation-functions/user-preference';

import { useGetAllInfieldLocations } from './use-query/cdm-use-get-all-infield-locations';

export interface UseLocationsContextInterface {
  useCurrentUserContext: typeof useCurrentUserContext;
  useGetAllInfieldLocations: () => ReturnType<typeof useGetAllInfieldLocations>;
  useUpsertCurrentUserPreferences: () => {
    mutateAsync: (
      userPreferencesUpdate: UserPreferencesUpdate
    ) => Promise<InFieldUserPreferences | undefined>;
  };
}

const defaultValue: UseLocationsContextInterface = {
  useCurrentUserContext,
  useGetAllInfieldLocations: () =>
    useSavedCdmConfiguration({
      useOnlineQuery: useGetAllInfieldLocations,
      select: (configuration) => configuration.locations,
    }),
  useUpsertCurrentUserPreferences,
};

export const UseLocationsContext =
  createContext<UseLocationsContextInterface>(defaultValue);
